import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloorManagementComponent } from 'src/app/floor-management/floor-management.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { FloorItemComponent } from './floor-item/floor-item.component';
import { FloorUnitItemComponent } from './floor-unit-item/floor-unit-item.component';
import { AddFloorDetailsComponent } from './add-floor-details/add-floor-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AccessControlModule } from '../libs/ui/directives/access-control/access-control.module';
import { RemoveFloorUnitComponent } from './remove-floor-unit/remove-floor-unit.component';
import { EditFloorUnitComponent } from './edit-floor-unit/edit-floor-unit.component';
import { ControlDisabledDirectiveModule } from '../libs/ui/directives/control-disabled/control-disabled-directive.module';
import { FloorAccessPointComponent } from './floor-access-point/floor-access-point.component';
import { SortByModule } from '../libs/ui/pipes/sort-by/sort-by.module';
import { EditAccesspointDetailsComponent } from './edit-accesspoint-details/edit-accesspoint-details.component';
import { FilterFloorsComponent } from './filter-floors/filter-floors.component';
import { NgPipesModule } from 'ngx-pipes';
import { SortPropertyPipeModule } from '../libs/ui/pipes/sort-property-pipe.module';
import { HideAccessModule } from '../libs/ui/directives/hide-access/hide-access.module';
import { WithTooltipModule } from '../shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from '../shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FloorManagementComponent,
    FloorItemComponent,
    FloorUnitItemComponent,
    AddFloorDetailsComponent,
    RemoveFloorUnitComponent,
    EditFloorUnitComponent,
    FloorAccessPointComponent,
    EditAccesspointDetailsComponent,
    FilterFloorsComponent,
  ],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ControlDisabledDirectiveModule,
    AccessControlModule,
    ControlDisabledDirectiveModule,
    SortByModule,
    FormsModule,
    NgPipesModule,
    SortPropertyPipeModule,
    HideAccessModule,
    TranslateModule
  ],
  exports: [
    FloorManagementComponent,
    AddFloorDetailsComponent,
    RemoveFloorUnitComponent,
    EditFloorUnitComponent,
    EditAccesspointDetailsComponent,
  ],
  providers: [
    LocalizationService,
    TranslateModule
  ]
})
export class FloorManagementModule {}
